import React from "react";
import AboutPortalHero from "./website/about-components/AboutPortalHero";
import AboutCsrPortal from "./website/about-components/AboutCsrPortal";
import WhoWeServe from "./website/about-components/WhoWeServe";
import ContactSupport from "./website/about-components/ContactSupport";
import GovernanceCompliance from "./website/about-components/GovernanceCompliance";
import TechnicalSupport from "./website/about-components/TechnicalSupport";
export default function About() {
    return(
        <>
        <AboutPortalHero />
        <AboutCsrPortal />
        {/* <WhoWeServe /> */}
        {/* <GovernanceCompliance /> */}
        <ContactSupport />
        {/* <TechnicalSupport /> */}

        </>
    )};